<template>
  <div class="month-count">
    <week-count v-for="(item,index) in monthData" :key="index" :weekDatas="item"></week-count>
  </div>
</template>

<script>
import weekCount from './weekCount.vue'
export default {
  components: {
    weekCount
  },
  props: [
    'monthData'
  ],
  created() {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/monthCount.vue